<ng-container *ngIf="flatValues">
  <oes-dynamic-form
    class="dynamic-form"
    [json]="flatValues"
    [readOnly]="true">
  </oes-dynamic-form>
</ng-container>
